import { GridApi } from '@ag-grid-community/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { CustomCostPopupComponent } from 'src/app/modules/analytics/analytics-page/custom-cost-popup/custom-cost-popup.component';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';

@Component({
  selector: "app-cost-tool-panel",
  templateUrl: "./cost-tool-panel.component.html",
  styleUrls: ["./cost-tool-panel.component.scss"],
})
export class CostToolPanelComponent implements OnInit, OnDestroy {
  gridApi: GridApi;
  costDetail;
  costList: any = [];
  loading: boolean = false;
  private destroy$ = new Subject<void>();
  remainingDays:any;
  isPeroid: boolean;
  month: any;
  currentDate= new Date();

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private planyardService: PlanyardService) {
    }

  ngOnInit(): void {}

  agInit(params: any): void {
    this.gridApi = params.api;
  }

  refresh() {
    this.costDetail= this.planyardService.selectedCostSku;
    this.costDetail.sku= this.costDetail.Sku;
    this.costDetail.title= this.costDetail.Title;
    this.costDetail.asin= this.costDetail.Asin;
    this.costDetail.image= this.costDetail.Image;
    this.costDetail.totalCost=  Number(this.costDetail.SkuPrep) + Number(this.costDetail.SkuCost ? this.costDetail.SkuCost : 0);
    this.getCostList();
  }

  getCostList() {
    this.planyardService.getCustomCost(this.costDetail.AccountSkuId).pipe(takeUntil(this.destroy$)).subscribe({
        next: (res) => {
            this.costList = res;
            this.costList.filter((ele, i) => {
                if (ele.dateTo) {
                    let dateTo = new Date(ele.dateTo);
                    this.month = dateTo.getMonth() + 1;
                    let currentMonth = this.currentDate.getMonth() + 1;
                    if (this.month === currentMonth && this.currentDate.getDate() <= dateTo.getDate()) {
                        this.costList[i].isHighlight = true;
                    }
                } else if (ele.qty) {
                    let dateFrom = new Date(ele.dateFrom);
                    if (dateFrom.getDate() === this.currentDate.getDate()) {
                        this.costList[i].isHighlight = true;
                    }
                }
            });
        },
        error: (err) => {
            this.snackBar.openFromComponent(SnackbarComponent, {
                duration: 4000,
                horizontalPosition: "center",
                data: {
                    title: err?.error?.error[0],
                    action: "Dismiss",
                    type: "error",
                },
            });
        }
    });
}

  edit(cost) {
    this.dialog
      .open(CustomCostPopupComponent, {
        width: "385px",
        data: {
          data: cost,
          title: "Edit Custom Cost",
        },
      })
      .afterClosed()
      .subscribe((e) => {
        if (e==="Confirm"){
        this.getCostList();
        }
      });
  }

  delete(customCostId) {
    const payload= {
      customCostId:customCostId
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Delete Cost",
          message: `Are you sure you want to delete this?`,
        },
      }).afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((confirmation) => {
        if (confirmation == "Confirm") {
          this.planyardService.deleteCost(payload).pipe(takeUntil(this.destroy$)).subscribe({
            next: (e) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                duration: 3000,
                horizontalPosition: "center",
                data: {
                  title: "Cost Details has been deleted successfully.",
                  action: "Dismiss",
                  type: "success",
                },
              });
              this.getCostList();
              this.gridApi.refreshServerSide({ purge: true });
            },
            error: (err) => {
              this.snackBar.openFromComponent(SnackbarComponent, {
                duration: 4000,
                horizontalPosition: "center",
                data: {
                  title: err.error?.error[0],
                  action: "Dismiss",
                  type: "error",
                },
              });
            }
          });
        }          
      });
  }

  addCustomCost(){
    this.costList.filter((ele)=>{
      if(ele.qty){
        this.isPeroid= false;
      } else{
        this.isPeroid= true;
      }})
    this.dialog.open(CustomCostPopupComponent, {
      width: "385px",
      data: {
        isPeroid: this.isPeroid,
        title: 'Add Custom Cost',
        accountSkuId: this.costDetail.AccountSkuId
      }
    }).afterClosed()
    .subscribe((e) => {
      if (e==="Confirm"){
        this.getCostList();
        this.gridApi.refreshServerSide({ purge: true });
      }
    });
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
